import React from "react";

type SchemaTableNameProps = {
  schema?: string | null;
  table?: string | null;
  className?: string;
  /**
   * "stacked" puts the schema on its own line, so a node's width follows the longer
   * of the two instead of their sum. Data Mart schemas run to 29 characters
   * (analytics_sustainability_dahl), which stretches a single-line label past 60.
   */
  layout?: "inline" | "stacked";
};

export function SchemaTableName({
  schema,
  table,
  className,
  layout = "inline"
}: SchemaTableNameProps): JSX.Element {
  const schemaName = schema ?? "";
  const tableName = table ?? "";
  const hasSchema = schemaName.length > 0;
  const hasTable = tableName.length > 0;

  if (!hasSchema && !hasTable) {
    return <span className={className}>Unnamed</span>;
  }

  if (layout === "stacked") {
    return (
      <span
        className={className}
        title={[schemaName, tableName].filter(Boolean).join(".")}
      >
        {hasSchema ? (
          <span className="tw-block tw-text-[11px] tw-font-medium tw-text-slate-500 tw-break-words">
            {schemaName}
          </span>
        ) : null}
        {hasTable ? (
          <span className="tw-block tw-text-slate-900 tw-break-words">{tableName}</span>
        ) : null}
      </span>
    );
  }

  return (
    <span className={className}>
      {hasSchema ? (
        <span className="tw-font-semibold tw-text-slate-600">{schemaName}</span>
      ) : null}
      {hasSchema && hasTable ? (
        <span className="tw-px-0.5 tw-font-bold tw-text-slate-800">.</span>
      ) : null}
      {hasTable ? (
        <span className="tw-font-semibold tw-text-slate-900">{tableName}</span>
      ) : null}
    </span>
  );
}
